import { InformationIcon, SectionHeader } from "~/common/components";

export const ResponseThemesTitle = ({ onClick }: { onClick: () => void }) => (
  <div className="flex items-center gap-2">
    <SectionHeader>Response themes</SectionHeader>
    <button onClick={onClick}>
      <InformationIcon className="size-4 text-gray-20" />
    </button>
  </div>
);
